export default __webpack_public_path__ + "assets/models/88182ebfc8164b8d169ebd732c062a43.glb";